var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationsMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.774 8.507h-.792L1.396 19.604l4.756-2.378 4.36 1.934 4.36-1.934 4.756 2.378-1.586-11.097h-.792"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M15.926 6.81c0 3.908-5.414 9.354-5.414 9.354S5.091 10.742 5.1 6.81a5.416 5.416 0 0 1 5.413-5.414 5.416 5.416 0 0 1 5.414 5.414Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeMiterlimit: 10,
  d: "M12.97 6.628a2.46 2.46 0 0 1-2.457 2.457 2.46 2.46 0 0 1-2.457-2.457 2.46 2.46 0 0 1 2.457-2.458 2.46 2.46 0 0 1 2.457 2.458Z"
})));
export default SvgLocationsMap;